import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banners/banner1.jpg';
import banner2 from '../assets/banners/banner2.jpg';
import banner3 from '../assets/banners/banner3.png';
import pr1 from '../assets/med/pr1.jpg';
import pr11 from '../assets/med/pr1-1.jpg';
import pr12 from '../assets/med/pr1-2.jpg';
import pr13 from '../assets/med/pr1-3.jpg';
import pr14 from '../assets/med/pr1-4.png';
import pr15 from '../assets/med/pr1-5.jpg';


import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import { MdArrowCircleLeft, MdArrowCircleRight } from "react-icons/md";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner1, banner2, banner3];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12 mt-3 mb-3">
								
								<h6
									className="main-section-title font-semi-bold text-dark"
								>
									93% PSA Oxygen Generators
								</h6>
							</div>

							<div className="col-md-4 mt-3 mb-3">
								<div 
									className="card"
									onClick={() => {
										appContext.navTo({
											item: 'services',
											subItem: 'oxygen_generator'
										})
									}}
									style={{
										cursor: "pointer",
									}}
								>
									<div className="card-body">
										<img
											style={{
												width: "100%",
												height: "auto",
												
											}}
											src={pr1}
										/>
									</div>
								</div>
							</div>

							<div className="col-md-8 mt-3 mb-3">
								<p
									style={{
										fontSize: "22px"
									}}
								>
									These Oxygen generators are medical devices designed to provide oxygen therapy to patients who require supplemental oxygen. Our oxygen generators are crafted with advanced technology to efficiently extract oxygen from ambient air, ensuring a high purity of oxygen for therapeutic use.
								</p>
							</div>

							<div className="col-md-12 mt-3 mb-3">
								<h6
									className="font-bold text-muted"
									style={{
										fontSize: "18px"
									}}
								>
									Product Detail
								</h6>

								Caremed's Oxygen generator system could supply pure oxygen for all kinds of hospitals and clinics continuously. Medical Oxygen Generators System uses state-of-the-art Pressure Swing Adsorption (PSA) technology to separate the oxygen from the surrounding air efficiently. This ensures that patients receive a consistent and adequate supply of oxygen.

								Our Oxygen plant equipment put the air as raw material, zeolite molecular sieve as adsorbent, under the normal temperature low pressure, using the selectivity of zeolite molecular sieve for oxygen adsorption. The purity is 93%±3%. In addition to the existing oxygen generators, we can also customize the oxygen generator system according to the installation conditions of the customer site and can be installed on-site for customers.

								<hr/>
							</div>
							

							<div className="col-md-12 mt-3 mb-3">
								<h6
									className="font-bold text-muted"
									style={{
										fontSize: "18px"
									}}
								>
									Working Principle
								</h6>
								
								After being dried and purified, the medical air enters the adsorption tower through a switching valve. In the adsorption tower, oxygen gas gathers at the top of the adsorption tower and then enters the oxygen storage tank. Dust, bacteria, and peculiar smell are removed by different filters to achieve high quality oxygen. Our oxygen plant allows the hospital to have stand-alone oxygen production capability directly on the facility site.

								<hr/>
							</div>

							<div className="col-md-12 mt-3 mb-3">
								<h6
									className="font-bold text-muted"
									style={{
										fontSize: "18px"
									}}
								>
									Specifications
								</h6>
								
								<ul>
									<li>Oxygen Generators Capacity: 3Nm³/h ~ 100Nm³/h (single unit)</li>
									<li>Medical Oxygen Purity: 93% ± 3% (with PSA technology)</li>
									<li>Power supply: 380V / 220V</li>
									<li>Very simple and easy to install</li>
									<li>Latest components to ensure smooth performance</li>
									<li>Oxygen for medical use is the best alternative to liquid oxygen supply and filled cylinders</li>
									<li>Out Pressure: 0.3 ~ 0.55 Mpa (adjustable)</li>
									<li>Operation Noise: ≤ 85dB(A)</li>
									<li>
										<strong>Higher separation efficiency:</strong> AmcareMed oxygen generators have higher separation
										efficiency than other PSA oxygen generators of the same type, requiring only a relatively small
										amount of air to obtain more oxygen.
									</li>
									<li>
										<strong>Easy to Install and Maintain:</strong> All parts of the oxygen generator are commissioned before
										leaving the factory and sent to the installation site together, making installation very easy.
										If necessary, professional installation personnel can be arranged to install and guide on site.
									</li>
									<li>
										<strong>Automatic and stable operation:</strong> 24/7 – 365 days fully automatic operation. Reliable,
										tested, and controlled components ensure smooth performance. Monitoring system allows automatic
										control and real-time display of pressure, purity, flow rate, and operating conditions, with
										alarm functions.
									</li>
									<li>
										<strong>Reliable Performance:</strong> AmcareMed oxygen generators are engineered for stability and
										reliability, delivering a continuous and stable flow of oxygen to patients during treatment.
									</li>
									<li>
										<strong>Safety Features:</strong> Compliant with EN ISO 7396, EN 60601, EN IEC 61000, and Directive
										93/42/EEC. Equipped with multiple safety features to ensure patient well-being.
									</li>
									<li>
										<strong>Energy Efficiency:</strong> Designed to be energy-efficient, reducing energy consumption and
										lowering treatment costs over time.
									</li>
								</ul>

								
								<hr/>
							</div>

							<div className="col-md-12 mt-3 mb-3">
								<h6
									className="font-bold text-primary text-center"
									style={{
										fontSize: "24px"
									}}
								>
									Related Products
								</h6>

								<div className="row">
									<div className="col-md-3 col-12 mt-3 mb-3">
										<div className="card">
											
											<div className="card-body">

												<img
													style={{
														width: "100%",
														height: "200px",
														objectFit: "cover",
														objectPosition: "center"
													}}
													src={pr11}
												/>

												<h6
													className="font-bold text-center mt-4 text-primary"
													
													style={{
														fontSize: "18px",
														height: "40px"
													}}
												>
													Screw Medical Air Compressor
													
												</h6>
												
											</div>
											
										</div>
									</div>

									<div className="col-md-3 col-12 mt-3 mb-3">
										<div className="card">
											
											<div className="card-body">

												<img
													style={{
														width: "100%",
														height: "200px",
														objectFit: "cover",
														objectPosition: "center"
													}}
													src={pr12}
												/>

												<h6
													className="font-bold text-center mt-4 text-primary"
													
													style={{
														fontSize: "18px",
														height: "40px"
													}}
												>
													Oxygen Tank
													
												</h6>
												
											</div>
											
										</div>
									</div>

									<div className="col-md-3 col-12 mt-3 mb-3">
										<div className="card">
											
											<div className="card-body">

												<img
													style={{
														width: "100%",
														height: "200px",
														objectFit: "cover",
														objectPosition: "center"
													}}
													src={pr13}
												/>

												<h6
													className="font-bold text-center mt-4 text-primary"
													
													style={{
														fontSize: "18px",
														height: "40px"
													}}
												>
													Refrigeration Air Dryer
													
												</h6>
												
											</div>
											
										</div>
									</div>

									<div className="col-md-3 col-12 mt-3 mb-3">
										<div className="card">
											
											<div className="card-body">

												<img
													style={{
														width: "100%",
														height: "200px",
														objectFit: "cover",
														objectPosition: "center"
													}}
													src={pr14}
												/>

												<h6
													className="font-bold text-center mt-4 text-primary"
													
													style={{
														fontSize: "18px",
														height: "40px"
													}}
												>
													Oxygen Booster Compressor
													
												</h6>
												
											</div>
											
										</div>
									</div>

									<div className="col-md-3 col-12 mt-3 mb-3">
										<div className="card">
											
											<div className="card-body">

												<img
													style={{
														width: "100%",
														height: "200px",
														objectFit: "cover",
														objectPosition: "center"
													}}
													src={pr15}
												/>

												<h6
													className="font-bold text-center mt-4 text-primary"
													
													style={{
														fontSize: "18px",
														height: "40px"
													}}
												>
													Cylinder Filling Ramp
													
												</h6>
												
											</div>
											
										</div>
									</div>
								</div>
							</div>
	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}
